export default __webpack_public_path__ + "static/media/services3.f32f2daa.jpg";